import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useFundManagementMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemRevenue */
  const menuItemRevenue = {
    id: "revenue",
    title: t("revnue.revenue"),
    url: baseRouteMakerForSuperAdmin(routes.REVENUE),
  };
  tempMenuGroup.push(menuItemRevenue);
  /* menuItemRevenue */

  /* menuItemPayroll */
  const menuItemPayroll = {
    id: "payroll",
    title: t("revnue.payroll"),
    url: baseRouteMakerForSuperAdmin(routes.PAYROLL),
  };
  tempMenuGroup.push(menuItemPayroll);
  /* menuItemPayroll */

  /* menuItemPricing */
  const menuItemPricing = {
    id: "pricing",
    title: t("revnue.pricingModel"),
    url: baseRouteMakerForSuperAdmin(routes.PRICING_MODEL),
  };
  tempMenuGroup.push(menuItemPricing);
  /* menuItemPricing */

  /* menuItemWalletManagement */
  const menuItemWalletManagement = {
    id: "walletManagement",
    title: t("revnue.walletManagement"),
    url: baseRouteMakerForSuperAdmin(routes.WALLET_MANAGEMENT),
  };
  tempMenuGroup.push(menuItemWalletManagement);
  /* menuItemWalletManagement */

  /* menuItemWalletTransactions */
  const menuItemWalletTransactions = {
    id: "walletTransactions",
    title: t("walletInfo.walletTransactions"),
    url: baseRouteMakerForSuperAdmin(routes.WALLET_TRANSACTIONS),
  };
  tempMenuGroup.push(menuItemWalletTransactions);
  /* menuItemWalletTransactions */

  return tempMenuGroup;
};
